/**
 * Gets a letter representation from an index, i.e. 1 -> A, 2 -> B, etc.
 */
export const getLetterFromNumber = (num: number) => {
  return String.fromCharCode(65 + num);
};
